import Cookies from "js-cookie";

const logout = () => {
  Cookies.remove("AccessToken");
  Cookies.remove("name");
  Cookies.remove("mobileNumber");
};
export default logout;
